const customSelectors = {};
var vehicleMobileInterval;
class customJS {
    constructor() {
      var _this = this;
        var navItem = document.querySelectorAll('.nav-child');
        if (navItem.length > 0) {
          navItem.forEach((nav) => {
            ["mouseover", "mouseout"].forEach(function(type){
              if(type == 'mouseover'){
                nav.addEventListener(type, (e) => {
                  e.target.closest('.navigation--wrapper').classList.add('hover-active');
                })
              } else if(type == 'mouseout'){
                nav.addEventListener(type, (e) => {
                  e.target.closest('.navigation--wrapper').classList.remove('hover-active');
                })
              }
            })
          })
        }

        if (document.body.classList.contains('template-404')) {
          var script = document.createElement( 'script' );
          script.defer = true;
          script.setAttribute( 'src', "https://cdn.doofinder.com/shopify/doofinder-installed.js" );
          document.head.appendChild(script);
          isSearchAdded = true; 
          document.querySelector('.desktop-doofinder-serach').click();
        } else {
         var searchSelector = document.querySelectorAll('.header-search');
         var isSearchAdded = false;
         if (window.innerWidth > 767) {
            ["mouseover", "touchend", "click"].forEach(function(type){
              searchSelector.forEach((item) => {
                item.addEventListener(type, () => {
                  if (!isSearchAdded) {
                    var script = document.createElement( 'script' );
                    script.defer = true;
                    script.setAttribute( 'src', "https://cdn.doofinder.com/shopify/doofinder-installed.js" );
                    document.head.appendChild(script);
                    isSearchAdded = true; 
                    if (window.innerWidth < 1200 || document.body.classList.contains('template-404')) {
                      document.querySelector('.desktop-doofinder-serach').click();
                    }
                  }
                }) 
              })
            });
         } else {
            ["click"].forEach(function(type){
              searchSelector.forEach((item) => {
                item.addEventListener(type, () => {
                  if (!isSearchAdded) {
                    var script = document.createElement( 'script' );
                    script.defer = true;
                    script.setAttribute( 'src', "https://cdn.doofinder.com/shopify/doofinder-installed.js" );
                    document.head.appendChild(script);
                    isSearchAdded = true; 
                    if (window.innerWidth < 1200 || document.body.classList.contains('template-404')) {
                      document.querySelector('.desktop-doofinder-serach').click();
                    }
                  }
                }) 
              })
            });
         }
        }

        var siteDoofinderSearch = document.querySelectorAll('.site-doofinder-search');
        if (siteDoofinderSearch.length > 0) {
          siteDoofinderSearch.forEach((item) => {
            item.addEventListener('click', (e) => {
              e.preventDefault();
              document.querySelector('.desktop-doofinder-serach').click();
            })
          })
        }
        var isEasySearchModal = false;
        if (window.innerWidth < 769) {
          window.addEventListener('scroll', function(e) {
            if (window.pageYOffset > 100 && !isEasySearchModal) {
              var script = document.createElement( 'script' );
              script.defer = true;
              script.setAttribute( 'src', "https://static.nexusmedia-ua.com/easysearch/externals/frontend/easysearch-1.0.1.js" );
              document.head.appendChild(script);
              isEasySearchModal = true;
              // setTimeout(() => {
              //   document.querySelector('#VehicleSearch-modal #easysearch_field_10757').closest('.select').querySelector('.select-styled').classList.add('active');
              // }, 500);
            }
          });
        }
        var vehicleSelector = document.querySelectorAll('#selectVehicle');
        ["mouseover", "touchend", "click"].forEach(function(type) {
          vehicleSelector.forEach((item) => {
            item.addEventListener(type, () => {
              if (!isEasySearchModal) {
                // Add blue border to first select when modal open
                document.querySelector('#VehicleSearch-modal .easysearch-select-holder:first-child .select .select-styled')?.classList.add('blue-border');
                
                var script = document.createElement( 'script' );
                script.defer = true;
                script.setAttribute( 'src', "https://static.nexusmedia-ua.com/easysearch/externals/frontend/easysearch-1.0.1.js" );
                document.head.appendChild(script);
                // setTimeout(() => {
                //   document.querySelector('#VehicleSearch-modal #easysearch_field_10757').closest('.select').querySelector('.select-styled').classList.add('active');
                // }, 500);
              }
            }) 
          })
        })
        
        vehicleMobileInterval = setInterval(_this.checkVehicleFit, 1000);
        if (window.innerWidth > 767) {
          if (document.querySelector('[data-desktop-show-1]') != null) {
            document.querySelector('[data-desktop-show-1]').addEventListener('mouseover', function() {
              var script = document.createElement( 'script' );
              script.defer = true;
              script.setAttribute( 'src', "https://static.nexusmedia-ua.com/easysearch/externals/frontend/easysearch-1.0.1.js" );
              document.head.appendChild(script);
              document.querySelector('[data-desktop-show-1]').style.opacity = 0;
              document.querySelector('[data-desktop-show]').classList.add('d-md-block');
              // (document.querySelector('[data-desktop-show] #easysearch_field_10757').closest('.select') != null) && document.querySelector('[data-desktop-show] #easysearch_field_10757').closest('.select').querySelector('.select-styled').classList.add('active');
              (document.querySelector('[data-desktop-show] #easysearch_field_10757').closest('.select') != null) && document.querySelector('[data-desktop-show] #easysearch_field_10757').closest('.select').querySelector('.select-styled').classList.add('blue-border');
              document.querySelector('[data-desktop-show-1]').classList.remove('d-md-block');
                // setTimeout(() => {
                //   document.querySelector('[data-desktop-show] #easysearch_field_10757').closest('.select').querySelector('.select-styled').classList.add('active');
                // }, 500);
            });
          } 
        } else {
          if (document.querySelector('[data-mobile-show-1]') != null) {
            ["click"].forEach(function(type){
              document.querySelector('[data-mobile-show-1]').addEventListener(type, function() {
                var script = document.createElement( 'script' );
                script.defer = true;
                script.setAttribute( 'src', "https://static.nexusmedia-ua.com/easysearch/externals/frontend/easysearch-1.0.1.js" );
                document.head.appendChild(script);
                document.querySelector('[data-mobile-show-1]').classList.remove('d-block');
                document.querySelector('[data-mobile-show-1]').classList.add('d-none');
                document.querySelector('[data-mobile-show]').classList.remove('d-none');
                document.querySelector('[data-mobile-show]').classList.add('d-block');
                document.querySelector('[data-mobile-show] #easysearch_field_10757').closest('.select').querySelector('.select-styled').classList.add('blue-border');
                setTimeout(() => {
                  document.querySelector('[data-mobile-show] #easysearch_field_10757').closest('.select').querySelector('.select-styled').classList.add('active');
                }, 150);
                // setTimeout(() => { 
                //   document.querySelector('[data-mobile-show] .easysearch-select-holder:first-child input.easyInput').click();
                // }, 1000);
              });
            })
          }
        }

      document.querySelector('#VehicleModalWrapper').addEventListener('click', function(e){
        var target = e.target;
        if(target.closest('.vehicleModalBody') == null) {
          document.querySelector('#VehicleSearch-modal button.close-quickshop').click();
        }
      })

      var registerPage = document.querySelector('[name="terms_and_condition_accepted"]');
      if(registerPage != null) {
         registerPage.addEventListener('change', function(e) {
             if(e.target.checked) {
               e.target.insertAdjacentHTML('afterend', '<input type="hidden" name="customer[tags]" value="terms_and_condition_accepted" id="termsAndConditionAccepted">');
             } else {
               document.querySelector('#termsAndConditionAccepted').remove();
             }
         }) 
      }
    }

    checkVehicleFit(){
      if(window.easysearch != undefined){
          var selectWrapper = document.querySelector('[data-mobile-select-wrapper]');
          clearInterval(vehicleMobileInterval);
          if (typeof(selectWrapper) != 'undefined' && selectWrapper != null){
            if(window.easysearch.preSelect.length > 0){
                var vehicleName = null;
                var vehicleNameElements = document.querySelector('[data-mobile-vehicle-name]');
                var preSelect = window.easysearch.preSelect.filter(item => item);
                preSelect.forEach(function(value,index){
                    if(vehicleName == null){
                        vehicleName = value;
                    }else{
                        vehicleName += ' ' + value;
                    }
                    
                    if(index == preSelect.length-1){
                        document.querySelector('[data-mobile-vehicle-success]').classList.remove('d-none');
                        document.querySelector('[data-mobile-vehicle-success]').classList.add('d-flex');
                        document.querySelector('[data-mobile-select-vehicle]').classList.remove('d-block');
                        document.querySelector('[data-mobile-select-vehicle]').classList.add('d-none');
                    }
                    
                    vehicleNameElements.innerHTML = vehicleName;
                });
            }else if(window.easysearch.preSelect.length == 0){
                document.querySelector('[data-mobile-select-vehicle]').classList.remove('d-none');
                document.querySelector('[data-mobile-select-vehicle]').classList.add('d-block');
            }
          }
          
      }
  }
}

typeof customJS !== 'undefined' && new customJS();

if (navigator.platform.indexOf("Mac") === 0 || navigator.platform === "iPhone") {
  document.querySelector('body').classList.add("ios-detected")
}

var ua = navigator.userAgent.toLowerCase();
var isAndroid = ua.indexOf("android") > -1;
if(isAndroid) {
  document.querySelector('body').classList.add("android-detected")
}

const ele = document.querySelector(".scroll-here-mobile");
if (ele != null && document.getElementById("hpVehicleContainer") != null) {
  /* Custom scroll Homepage Mobile */
  const toScroll = document.getElementById("hpVehicleContainer").offsetTop + document.querySelector('sticky-header').offsetHeight;
  
  ele?.addEventListener("click", () => {
    window.scrollTo({ top: toScroll, behavior: 'smooth'});
      // toScroll.scrollIntoView({ behavior: "smooth", block: "start" });
  });
}

// Close selector dropdown when outside is clicked
document.addEventListener('click', function(event) {
  var targetElement = event.target;
  var isSelectStyled = targetElement.classList.contains('select-styled') || 
  targetElement.querySelector('.select-styled');
  
  if (!isSelectStyled) {
    var selectStyledElements = document.querySelectorAll('.select-styled.active');
    selectStyledElements.forEach(function(element) {
      element.classList.remove('active');
    });
  }
});

// Add class when user scroll (For YMM dropdown position)
document.addEventListener('DOMContentLoaded', function() {
  function checkScrollPosition() {
    if (window.scrollY > 200) {
      document.body.classList.add('ymm-dropdown-bottom');
    } else {
      document.body.classList.remove('ymm-dropdown-bottom');
    }
  }

  checkScrollPosition();

  window.addEventListener('scroll', checkScrollPosition);
});
